module.exports = __webpack_public_path__ + "static/img/banner2.3eb9a42.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/banner2.png
// module id = v1n7
// module chunks = 0